module.exports = __webpack_public_path__ + "img/team_3_index.be62c06c.png";